export const FROM_PLACEHOLDER ="Enter Source";
export const TO_PLACEHOLDER = "Enter Destination";
export const PAGE_NAMES = {
  route: "seo:domestic bus:listing:route",
  city: "seo:domestic bus:listing:city",
  operator: "seo:domestic bus:listing:operator",
  route_category: "seo:domestic bus:listing:route_category",
  route_operator: "seo:domestic bus:listing:route_operator",
  city_category: "seo:domestic bus:listing:city_category",
  rtc_service: "seo:domestic bus:listing:rtc_service",
  route_operator_category: "seo:domestic bus:listing:route_operator_category",
  busstop: "seo:domestic bus:listing:busstop",
  category: "seo:domestic bus:listing:category"
  }